// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"bf_bv","reviews__wrapper__list":"bf_fp","reviewSlider":"bf_fq"};